import id from './package/id'
import en from './package/en'
export default {
  id,
  en
}
